import React from "react";
import { Link } from "react-router-dom";
import { CATEGORY_LABEL } from "../../lib/categories";

export default function ProductCard({ product, testId }) {
    return (
        <article
            data-testid={testId || `product-${product.id}`}
            className="premium-card group flex flex-col overflow-hidden p-3 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_80px_-55px_rgba(44,39,36,0.75)]"
        >
            <Link
                to={product.category === "buch" ? "/buecher" : "/produkte"}
                className="block aspect-[4/5] relative overflow-hidden rounded-[1.35rem] bg-cream-100"
            >
                <img
                    src={product.image_url}
                    alt={product.name}
                    onError={(e) => {
                        e.currentTarget.style.opacity = "0.4";
                    }}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
                <div className="absolute left-4 top-4 rounded-full bg-cream-50/90 backdrop-blur-sm border border-white/70 px-3 py-1.5">
                    <span className="text-[9px] tracking-[0.24em] uppercase text-ink-700 font-light">
                        {CATEGORY_LABEL[product.category] || product.category}
                    </span>
                </div>
                <div className="absolute right-4 bottom-4 rounded-full bg-ink-900/85 px-3 py-1.5 backdrop-blur-sm">
                    <span className="text-[9px] tracking-[0.24em] uppercase text-cream-50 font-light">
                        Bald erhältlich
                    </span>
                </div>
            </Link>

            <div className="flex flex-1 flex-col px-3 pb-3 pt-5">
                <h3 className="font-serif text-2xl text-ink-900 leading-tight">
                    {product.name}
                </h3>
                <p className="mt-3 text-sm text-ink-700 leading-relaxed font-light line-clamp-3">
                    {product.description}
                </p>
                <a
                    href={`https://wa.me/4915229516378?text=${encodeURIComponent(
                        `Hallo, ich möchte benachrichtigt werden, sobald ${product.name} verfügbar ist.`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 inline-flex items-center justify-center rounded-full border border-ink-900/15 bg-cream-50 px-5 py-3 text-[10px] tracking-[0.22em] uppercase text-ink-900 transition-colors hover:bg-ink-900 hover:text-cream-50"
                >
                    Benachrichtigen lassen
                </a>
            </div>
        </article>
    );
}
